
import '../../../css/pages/note_editor.less'
import { downloadNote, getNoteContent } from './course_note_panel_new'
import {debounce} from "lodash";
Vue.component("my_note_content", {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    keyword: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      content: '',
      courseLink: '',
      isMobile: window.innerWidth <= 768
    }
  },
  mounted() {
    window.addEventListener('resize', this.isMobileFn)
  },
  beforeDestroy() {
    window.removeEventListener('resize',this.isMobileFn)
  },
  watch: {
    data: {
      handler(newVal) {
        if (newVal && newVal.notes && newVal.notes.length) {
          this.formatNote()
          this.getCourseLink()
        }
      },
      deep: true,
      immediate: true
    },
    keyword: {
      handler(newVal) {
        this.formatNote()
      },
      immediate: true
    }
  },
  methods: {
    isMobileFn: debounce(function (){
      this.isMobile =  window.innerWidth <= 768;
    },200),
    // 时长转换，百纳秒转时分秒
    durationTrans(a) {
      a = parseInt((a || 0) / 10000000)
      var b = ""
      var h = parseInt(a / 3600),
        m = parseInt(a % 3600 / 60),
        s = parseInt(a % 3600 % 60);
      h = h < 10 ? '0' + h : h
      m = m < 10 ? '0' + m : m
      s = s < 10 ? '0' + s : s
      b += h + ":" + m + ":" + s
      return b;
    },
    highLightFormat(str) {
      if (!this.keyword) return str
      let replaceReg = new RegExp(this.keyword, 'g')
      let replaceString = '<span style="color:var(--color-primary);">' + this.keyword + '</span>' // 高亮替换v-html值
      return str.replace(/(?:[^<]|<(?!\/?\w)|(?!<)\w+>)+/g, (v) => {
        //通过正则把把过滤掉标签的数据关键字套个标签加上写好高亮样式的类名
        return v.replace(replaceReg, replaceString)
      })
    },
    formatNote() {
      let str = ''
      this.data.notes.map(note => {
        if (note.type == 'richText') {
          str += this.highLightFormat(note.note)
        } else {
          //兼容老数据
          if (note.keyframe) {
            //截图笔记
            str += `<div class="custom_screenshoot" contenteditable="false">
                            <img class="keyframe" src="${note.keyframe}" />
                            <img class="icon" src="/learn/static/imgs/play_icon.png" />
                            <span class="time">${this.durationTrans(note.pointIn)}</span>
                        </div>`
            if (note.remark) {
              str += `<p>${this.highLightFormat(note.remark)}</p>`
            }
          } else if (note.note) {
            //语音文本笔记
            str += `<div class="custom_text" contenteditable="false">
                            <div class="time"><img class="icon" src="/learn/static/imgs/play_icon.png" />${this.durationTrans(note.pointIn)}</div>
                            <div class="text_content">${this.highLightFormat(note.note)}</div>
                        </div>`
            if (note.remark) {
              str += `<p>${this.highLightFormat(note.remark)}</p>`
            }
          } else if (note.remark) {
            //文本笔记
            str += `<p>${this.highLightFormat(note.remark)}</p>`
          }
        }
      })
      this.content = str
    },
    getCourseLink() {
      let noteData = this.data.notes[0] || {}
      if (noteData.noteType == 'mooc' || noteData.noteType == 'spoc' || noteData.noteType == 'training') {
        this.courseLink = '/learn/course/' + noteData.noteType + '/' + noteData.courseId + '/' + noteData.resourceId + '?semester=' + noteData.semesterId
      } else if (noteData.noteType == 'micro') {
        this.courseLink = '/learn/course/micro/' + noteData.courseId
      } else if (noteData.noteType == 'review') {
        this.courseLink = '/learn/videoreview/' + noteData.courseId + '?schoolYear=' + noteData.schoolYear + '&semester=' + noteData.semester
      } else if (noteData.noteType == 'live-active') {
        this.courseLink = '/learn/live/activity/' + noteData.courseId
      } else if (noteData.noteType == 'live-course') {
        this.courseLink = '/learn/live/course/' + noteData.courseId
      }
    },
    handleDelete() {
      let ids = this.data.notes.map(el => el.id)
      API.reqCourseNoteDel(ids).then(res => {
        if (res.statusCode == 200 && res.data) {
          this.$message.success('删除成功！')
          this.$emit('delete')
        } else {
          this.$message.error(res.message || '删除失败！')
        }
      })
    },
    handleDownload() {
      let data = []
      let courseName, resourceName
      this.data.notes.map(item => {
        let note = ''
        if (item.type != 'richText') {
          note = getNoteContent(item)
        } else {
          note = item.note
        }
        data.push({
          courseName: note.courseName,
          sectionName: note.sectionName,
          resourceName: note.resourceName,
          noteContent: note,
          isLearn: true,
          noteType: 'richText'
        })
        if (!courseName) courseName = item.courseName
        if (!resourceName) resourceName = item.resourceName
      })
      downloadNote(data, { courseName, resourceName })
    }
  },
  template: `
  <div class="my_note_content" :id="'note_' + data.guid_">
      <div class="note_header">
        <div class="header_left">
          <div class="courseware_name">{{data.chapter_name}}</div>
          <a v-if="!isMobile"  :href="courseLink" target="_blank">前往学习 ></a>
        </div>
        <div v-if="!isMobile"  class="header_right">
          <a :href="courseLink" target="_blank">编辑</a>
          <a @click="handleDownload">下载</a>
          <el-popconfirm title="确认删除当前笔记？" @confirm="handleDelete">
            <a class="del_btn" slot="reference">删除111</a>
          </el-popconfirm>
        </div>
      </div>
      <div class="mce-content-body" v-html="content">
  </div>
  `,
});